export default {
  checkout: {
    seo: {
      cartTitle: 'Carrito de paseos | AQUAMARINA TOURS',
      cartDescription: 'Tu carrito de paseos en Paraty. Agrega paseos en barco, lancha y jeep a tu lista y reserva por WhatsApp.',
    },
    cart: {
      item: 'artículo',
      items: 'artículos',
      clear: 'Vaciar carrito',
      tourDate: 'Fecha del paseo:',
      review: 'Revisa los paseos seleccionados y confirma tu reserva con pago seguro.',
      deposit: 'Seña vía PIX',
      remaining: 'Saldo el día del paseo',
      depositNote: 'La seña corresponde al {{percent}}% del total, con un mínimo de R$ 20,00.',
      full: 'Pago total vía PIX',
      fullNote: 'El valor total se paga ahora para asegurar la reserva.',
      continuePayment: 'Continuar al pago',
      clearConfirmTitle: '¿Vaciar el carrito?',
      clearConfirmText: 'Se eliminarán todos los artículos. Esta acción no se puede deshacer.',
      cancel: 'Cancelar',
      clearConfirm: 'Vaciar',
    },
    modal: {
      titlePix: 'Paga la seña con Pix',
      titleDetails: 'Datos del responsable',
      close: 'Cerrar',
      adults_one: '{{count}} adulto',
      adults_other: '{{count}} adultos',
      children_one: '{{count}} niño',
      children_other: '{{count}} niños',
      babies_one: '{{count}} bebé',
      babies_other: '{{count}} bebés',
      participants_one: '{{count}} participante',
      participants_other: '{{count}} participantes',
      depositLabel: 'Seña vía Pix ({{percent}}%)',
      remainingNote: 'El saldo ({{amount}}) se paga el día del paseo.',
      qrAlt: 'Código QR Pix',
      scanHint: 'Escanea el código QR en la app de tu banco o usa el código Pix copia y pega.',
      copied: '¡Código copiado!',
      copyPix: 'Copiar código Pix',
      waiting: 'Esperando el pago — la confirmación aparecerá aquí automáticamente.',
      fillIn: 'Completa los datos de quien va a reservar.',
      fullName: 'Nombre completo',
      fullNamePlaceholder: 'Nombre y apellido',
      whatsapp: 'WhatsApp',
      ticketEmailHint: 'Tu ticket llegará a este email apenas se confirme la reserva.',
      pickupLabel: 'Dónde te recogemos',
      pickupPlaceholder: 'Hotel, posada o dirección en Paraty',
      pickupAgency: 'Embarcar en la agencia',
      pickupHint: 'Recogida gratis de 10:20 a 11:00 en el centro de Paraty (hasta 3 km de la agencia). El guía te confirma la hora por WhatsApp.',
      pickupAgencyHint: 'Embarcas en la agencia: la hora de llegada viene en tu ticket.',
      email: 'Correo electrónico',
      emailPlaceholder: 'tu@ejemplo.com',
      cpf: 'CPF',
      requiredOnline: '(obligatorio para pagar en línea)',
      talkWhatsApp: 'Hablar con el equipo por WhatsApp',
      generatingPix: 'Generando Pix…',
      payPix: 'Pagar seña de {{amount}} con Pix',
      sendWhatsApp: 'Enviar reserva por WhatsApp',
      openingMp: 'Abriendo Mercado Pago…',
      payCard: 'Prefiero pagar con tarjeta (Mercado Pago)',
      secure: 'Pagos procesados de forma segura por Mercado Pago',
      errors: {
        fullName: 'Ingresa nombre y apellido.',
        whatsapp: 'Ingresa un WhatsApp con código de área.',
        email: 'Ingresa un correo electrónico válido.',
        cpf: 'CPF inválido.',
        pickup: 'Dinos dónde te recogemos o elige embarcar en la agencia.',
        offline: 'El pago en línea solo funciona en el sitio publicado (o con "npx netlify dev"). Puedes enviar la reserva por WhatsApp.',
        generic: 'No fue posible completar la operación.',
        pixFailed: 'No fue posible generar el Pix.',
        paymentFailed: 'No fue posible iniciar el pago.',
      },
    },
    flow: {
      steps: { cart: 'Carrito', holder: 'Responsable', payment: 'Pago', confirm: 'Confirmación' },
      stepOf: 'Paso {{current}} de {{total}}',
      titles: {
        payment: '¿Cómo prefieres pagar?',
        approved: 'Pago aprobado',
        inProcess: 'Pago en revisión',
        rejected: 'Pago no aprobado',
      },
      summary: {
        title: 'Resumen de la reserva',
        show: 'Ver resumen',
        hide: 'Ocultar resumen',
        total: 'Total',
        dueNow: 'Seña cobrada ahora ({{percent}}%)',
        dueNowPlain: 'Seña cobrada ahora',
        fullNow: 'Pago total cobrado ahora',
        dueNowShort: 'Seña ahora',
        dueOnDay: 'Resto el día del paseo',
        date: 'Fecha',
        guests: 'Participantes',
        empty: 'Tu bolsa está vacía.',
      },
      document: {
        legend: 'Documento',
        cpf: 'CPF',
        passport: 'Pasaporte',
        cpfHint: 'Solo números; el formato es automático.',
        passportNumber: 'Número de pasaporte',
        passportPlaceholder: 'Ej.: AB1234567',
        passportHint: 'Para visitantes extranjeros.',
        nationality: 'País del pasaporte',
        nationalityPlaceholder: 'Selecciona el país',
        frequent: 'Más comunes',
        allCountries: 'Todos los países',
      },
      errors: {
        passport: 'Ingresa el número de pasaporte (5 a 20 letras o números).',
        nationality: 'Selecciona el país del pasaporte.',
        pixNeedsCpf: 'Mercado Pago pidió CPF para este Pix. Ingresa un CPF o confirma tu reserva por WhatsApp.',
        cardSdk: 'No pudimos cargar el formulario seguro de la tarjeta. Revisa tu conexión e inténtalo de nuevo, o paga en el checkout de Mercado Pago.',
      },
      actions: {
        continue: 'Continuar al pago',
        back: 'Volver',
        editDetails: 'Editar',
        whatsappInstead: 'Prefiero enviar la reserva por WhatsApp',
        retry: 'Intentar de nuevo',
        tryAnotherCard: 'Probar con otra tarjeta',
        payWithPix: 'Pagar con Pix',
        payWithCard: 'Pagar con tarjeta de crédito',
        newPix: 'Generar un nuevo Pix',
        showPix: 'Ver el código QR del Pix',
        viewReservation: 'Ver mi reserva',
        otherMethod: 'Otra forma de pago',
      },
      whatsappNote: 'Para enviarla por WhatsApp bastan nombre y WhatsApp.',
      tabs: { label: 'Forma de pago', pix: 'Pix', card: 'Tarjeta de crédito' },
      pix: {
        instant: 'Confirmación al instante',
        validity: 'Código QR válido por 30 minutos',
        anyBank: 'Funciona en la app de cualquier banco brasileño',
        passportNote: 'Con pasaporte, algunos bancos y cuentas exigen CPF para Pix. Si no funciona, confirma tu reserva por WhatsApp.',
        expiresIn: 'Vence en {{time}}',
        expired: 'Este Pix venció. Genera un código nuevo para pagar.',
        paste: 'Pix copia y pega',
      },
      card: {
        lead: 'Seña de {{amount}} en hasta 3 cuotas. Los datos de la tarjeta van directo a Mercado Pago, sin pasar por nuestro sitio.',
        loading: 'Cargando formulario seguro…',
        processing: 'Procesando el pago…',
        fallbackNote: 'Te llevaremos al checkout seguro de Mercado Pago para pagar con tarjeta (hasta 3 cuotas) y volverás al sitio al terminar.',
        fallbackButton: 'Pagar {{amount}} con tarjeta en Mercado Pago',
      },
      result: {
        approvedDesc: 'Tu seña está pagada y la reserva confirmada. Abriendo tu confirmación…',
        inProcessDesc: 'Mercado Pago está revisando el pago. Recibirás la respuesta por email, normalmente en pocos minutos.',
        rejectedDesc: 'No se cobró nada. Puedes probar con otra tarjeta o pagar con Pix.',
        paymentId: 'Pago n.º {{id}}',
      },
      statusDetail: {
        accredited: 'Pago aprobado.',
        pending_contingency: 'Estamos procesando el pago. En hasta 2 días hábiles recibirás el resultado por email.',
        pending_review_manual: 'El pago está en revisión. En hasta 2 días hábiles recibirás el resultado por email.',
        cc_rejected_bad_filled_card_number: 'Revisa el número de la tarjeta.',
        cc_rejected_bad_filled_date: 'Revisa la fecha de vencimiento de la tarjeta.',
        cc_rejected_bad_filled_other: 'Revisa los datos de la tarjeta.',
        cc_rejected_bad_filled_security_code: 'Revisa el código de seguridad (CVV) de la tarjeta.',
        cc_rejected_blacklist: 'No pudimos procesar el pago con esta tarjeta. Usa otra tarjeta o Pix.',
        cc_rejected_call_for_authorize: 'Tu banco pide autorizar este pago. Llama al banco e inténtalo de nuevo.',
        cc_rejected_card_disabled: 'Esta tarjeta no está activa. Llama al banco para activarla o usa otra tarjeta.',
        cc_rejected_card_error: 'No pudimos procesar el pago. Inténtalo de nuevo o usa otra tarjeta.',
        cc_rejected_duplicated_payment: 'Ya hiciste un pago por este monto. Si necesitas pagar de nuevo, usa otra tarjeta o Pix.',
        cc_rejected_high_risk: 'El pago fue rechazado por seguridad. Usa otra tarjeta o paga con Pix.',
        cc_rejected_insufficient_amount: 'La tarjeta no tiene saldo suficiente. Usa otra tarjeta o Pix.',
        cc_rejected_invalid_installments: 'Esta tarjeta no acepta esa cantidad de cuotas. Paga en una cuota o usa otra tarjeta.',
        cc_rejected_max_attempts: 'Llegaste al límite de intentos. Usa otra tarjeta o Pix.',
        cc_rejected_other_reason: 'El banco no aprobó el pago. Usa otra tarjeta o Pix.',
        default: 'El pago no fue aprobado. Usa otra tarjeta o paga con Pix.',
      },
    },
    paymentReturn: {
      loadingTitle: 'Verificando tu pago…',
      approvedTitle: 'Pago aprobado',
      pendingTitle: 'Pago pendiente',
      failedTitle: 'Pago no completado',
      loadingDesc: 'Estamos confirmando el resultado con Mercado Pago.',
      approvedDesc: 'Tu reserva está confirmada. Envía la confirmación por WhatsApp para que el equipo aparte tus lugares.',
      pendingDesc: 'Mercado Pago todavía está procesando el pago. En cuanto se apruebe, tu reserva quedará confirmada.',
      failedDesc: 'No se confirmó ningún cobro. Puedes intentarlo de nuevo o hablar con el equipo por WhatsApp.',
      emailSent: 'Enviamos tu ticket en PDF al correo electrónico indicado.',
      emailFailed: 'La reserva fue confirmada, pero no pudimos enviar el correo. Puedes abrir el ticket abajo.',
      sendConfirmation: 'Enviar confirmación por WhatsApp',
      talkTeam: 'Hablar con el equipo por WhatsApp',
      viewTicket: 'Ver mi ticket',
      backToCart: 'Volver al carrito',
      confirmedTitle: '¡Reserva confirmada!',
      thanks: '¡Gracias, {{name}}! Tu lugar en {{tour}} está asegurado. Nos vemos a bordo.',
      ticketByEmail: 'Tu ticket llega a tu email {{email}} y también puedes descargarlo en PDF.',
      summaryDate: 'Fecha',
      summaryPeople: 'Personas',
      summaryPaid: 'Seña pagada',
      summaryRemaining: 'Resto el día del paseo',
      ticketHeadline: 'RESERVA CONFIRMADA',
      ticketDate: 'Fecha',
      ticketPeople: 'Personas',
      ticketCode: 'Código',
      ticketPaid: 'PIX ✓ PAGADO',
    },
    ticket: {
      notFound: 'Ticket no encontrado',
      backToSite: 'Volver al sitio',
      title: 'Ticket de reserva',
      holder: 'RESPONSABLE',
      whatsapp: 'WhatsApp: {{phone}}',
      confirmed: 'CONFIRMADA',
      participants_one: '{{count}} participante',
      participants_other: '{{count}} participantes',
      total: 'Total',
      depositPaid: 'Seña pagada',
      downloadPdf: 'Descargar PDF',
      addWallet: 'Añadir a Wallet',
      walletAlert: 'Wallet requiere configurar Apple Wallet o Google Wallet como emisor.',
    },
  },
};
